import { render, staticRenderFns } from "./comfirmQuoOrder.vue?vue&type=template&id=d64d55d0&scoped=true"
import script from "./comfirmQuoOrder.vue?vue&type=script&lang=js"
export * from "./comfirmQuoOrder.vue?vue&type=script&lang=js"
import style0 from "./comfirmQuoOrder.vue?vue&type=style&index=0&id=d64d55d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64d55d0",
  null
  
)

export default component.exports